"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const _ActionTypes = require("./actionTypes");
const providesStatusLens = monocle.Lens.fromProp('providesStatus');
const providesLens = monocle.Lens.fromProp('provides');
const statusLens = monocle.Lens.fromProp('status');
const bidLens = monocle.Lens.fromProp('bid');
const pathLens = monocle.Lens.fromProp('path');
const featuresLens = monocle.Lens.fromProp('features');
const printProvidersLens = monocle.Lens.fromProp('printProviders');
const documentsLens = monocle.Lens.fromProp('documents');
const attachmentsLens = monocle.Lens.fromProp('attachments');
const questionsLens = monocle.Lens.fromProp('questions');
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const initialState = {
        providesStatus: 'STANDBY',
        provides: false,
        status: 'STANDBY',
        bid: null,
        path: [],
        features: 0,
        printProviders: []
    };
    const methods = {};
    methods[ActionTypes.FETCH_REQUEST] = (state, action) => statusLens.set('FETCHING')(state);
    methods[ActionTypes.FETCH_SUCCESS] = (state, action) => fp.function.compose(questionsLens.set(action.payload.questions), attachmentsLens.set(action.payload.attachments), documentsLens.set(action.payload.documents), printProvidersLens.set(action.payload.printProviders), featuresLens.set(action.payload.features), pathLens.set(action.payload.path), bidLens.set(action.payload.bid), statusLens.set('FETCHED'))(state);
    methods[ActionTypes.FETCH_FAILED] = (state, action) => statusLens.set('FAILED')(state);
    methods[ActionTypes.FETCH_PROVIDES_STATUS_REQUEST] = (state, action) => providesStatusLens.set('FETCHING')(state);
    methods[ActionTypes.FETCH_PROVIDES_STATUS_SUCCESS] = (state, action) => fp.function.compose(providesLens.set(!action.payload), providesStatusLens.set('FETCHED'))(state);
    methods[ActionTypes.FETCH_PROVIDES_STATUS_FAILED] = (state, action) => providesStatusLens.set('FAILED')(state);
    methods[ActionTypes.CLEAR] = (state, action) => (Object.assign({}, initialState));
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return { reducer, initialState, methods, ActionTypes };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map